module.exports = __webpack_public_path__ + "static/media/dark-submenu-servicos.e6bde097.svg";